module.exports = __webpack_public_path__ + "media/images/frontend/quedateencasa-20568858150ae476d0eca11d0f4498c7.png";